import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import RequestModal from "./RequestModal"; // Import the modal component

const ProductDetail = () => {
  const { id } = useParams();
  const [products, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false); // State for modal visibility

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`https://agpipefitting.org.et/api/product_descriptions/${id}`);
        if (response.data) {
          setProduct(response.data);
        } else {
          setError("Product not found.");
        }
      } catch (err) {
        setError("Failed to load product details.");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 text-danger">
        <h5>{error}</h5>
      </div>
    );
  }

  const price = parseFloat(products.price);
  const displayPrice = !isNaN(price) ? `ETB ${price.toFixed(2)}` : "Price not available";

  return (
    <div className="container py-5">
      <div className="row g-5 align-items-center">
        <div className="col-lg-6">
          <div className="rounded-4 overflow-hidden shadow-lg">
            <img
              src={`https://agpipefitting.org.et/storage/${products.image}`}
              alt={products.description}
              className="img-fluid w-100"
              style={{ objectFit: "cover", maxHeight: "500px" }}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <h2 className="fw-bold text-primary mb-3">{products.type}</h2>
         
          <div className="mb-4">
          
            <small className="text-secondary">{products.quantity} items available</small>
          </div>
          
          {/* Button to open RequestModal */}
          <button 
            className="btn btn-primary btn-lg px-4 py-2 rounded-pill shadow"
            onClick={() => setShowModal(true)} // Open modal on click
          >
            <i className="bi bi-envelope me-2"></i> Inquire Now
          </button>
        </div>
      </div>

      <div className="mt-5">
        <h3 className="fw-bold mb-4">About This Product</h3>
        <p className="text-muted fs-5" style={{ lineHeight: "1.8" }}>{products.description}</p>
      </div>

      {/* RequestModal Component */}
      <RequestModal show={showModal} handleClose={() => setShowModal(false)} />
    </div>
  );
};

export default ProductDetail;
